export default "assets/images/icons/clock-9299cdc3.svg";